/* Himmel in der BSP-Ansicht: welche Schalter es gibt und welche Flächen ausgeblendet werden. Ohne DOM. */

/** Name der Sky-Textur (großgeschrieben verglichen) */
export const SKY_TEX = 'SKY';

export const isSkyFace = (tex: string): boolean => String(tex).toUpperCase() === SKY_TEX;

/** Hat die BSP Flächen mit der Sky-Textur? */
export const bspHasSky = (polys: readonly { tex: string }[]): boolean => polys.some((p) => isSkyFace(p.tex));

/** Welche Schalter in der 3D-Leiste erscheinen:
 *  hideSky nur in der BSP-Ansicht und nur, wenn die BSP Sky-Flächen hat (sie verdecken sonst Karten von oben);
 *  skybox nur in der BSP-Ansicht, wenn die Himmelsbilder geladen sind (schaltet sie global an/aus);
 *  hideCeilings in jeder BSP-Ansicht. */
export function skyToggles(bsp: { hasSky: boolean } | null, skyboxLoaded: boolean): { hideSky: boolean; skybox: boolean; hideCeilings: boolean } {
  return { hideSky: !!bsp && bsp.hasSky, skybox: !!bsp && skyboxLoaded, hideCeilings: !!bsp };
}

/** Anfangszustand der Anzeige-Schalter (Himmel, Decken, Entities, Modelle); jede neu geöffnete Karte beginnt damit */
export const VIEW_DEFAULTS = { hideSky: false, hideCeilings: false, showEnts: true, showModels: true } as const;
